import React from 'react';
import { Star, BookOpen, TrendingUp } from 'lucide-react';
import { CompanyIcon, fmtPrice, fmtVal, fmtLot } from './CompanyCard';
import { useApp } from '../context/AppContext';

export default function CompanyTable({ companies, onOrderBook, onBuy }) {
  const { watchlist, toggleWatchlist } = useApp();
  return (
    <div className="rounded-xl border border-[var(--border)] overflow-hidden bg-[var(--panel)]">
      <div className="overflow-x-auto">
        <table className="w-full text-left">
          <thead>
            <tr className="text-[10px] font-mono tracking-[0.12em] text-[var(--muted-2)] border-b border-[var(--border)]">
              <th className="py-3 px-5 font-normal">COMPANY</th>
              <th className="py-3 px-3 font-normal">CATEGORY</th>
              <th className="py-3 px-3 font-normal text-right">LAST PRICE</th>
              <th className="py-3 px-3 font-normal text-right">24H</th>
              <th className="py-3 px-3 font-normal text-right">VALUATION</th>
              <th className="py-3 px-3 font-normal text-right">BID / ASK</th>
              <th className="py-3 px-3 font-normal text-right">MIN LOT</th>
              <th className="py-3 px-5 font-normal text-right">ACTIONS</th>
            </tr>
          </thead>
          <tbody>
            {companies.map((c) => {
              const up = c.change >= 0;
              const inWatch = watchlist.includes(c.id);
              return (
                <tr key={c.id} className="border-b border-[var(--border-soft)] hover:bg-[var(--panel-2)] transition-colors">
                  <td className="py-3.5 px-5">
                    <div className="flex items-center gap-3">
                      <button onClick={() => toggleWatchlist(c.id)} className="text-[var(--muted-2)] hover:text-[var(--orange)]">
                        <Star size={14} className={inWatch ? 'fill-[var(--orange)] text-[var(--orange)]' : ''} />
                      </button>
                      <div className="w-8 h-8 rounded-md bg-[#1c1710] border border-[#3a2a18] flex items-center justify-center">
                        <CompanyIcon name={c.icon} size={15} />
                      </div>
                      <div>
                        <div className="text-[13px] text-white font-medium">{c.name}</div>
                        <div className="text-[10px] font-mono text-[var(--orange)]">{c.ticker}</div>
                      </div>
                    </div>
                  </td>
                  <td className="py-3.5 px-3 text-[12px] text-[var(--muted)]">{c.category}</td>
                  <td className="py-3.5 px-3 text-right font-mono text-[13px] text-[var(--orange)]">{fmtPrice(c.lastPrice)}</td>
                  <td className={`py-3.5 px-3 text-right font-mono text-[12px] ${up ? 'text-[var(--green)]' : 'text-[var(--red)]'}`}>
                    {up ? '+' : ''}{c.change.toFixed(2)}%
                  </td>
                  <td className="py-3.5 px-3 text-right font-mono text-[13px] text-[var(--salmon)]">{fmtVal(c.valuation)}</td>
                  <td className="py-3.5 px-3 text-right font-mono text-[12px] text-[var(--text)]">{fmtPrice(c.bid)} / {fmtPrice(c.ask)}</td>
                  <td className="py-3.5 px-3 text-right font-mono text-[12px] text-[var(--text)]">{fmtLot(c.minLot)}</td>
                  <td className="py-3.5 px-5">
                    <div className="flex items-center justify-end gap-2">
                      <button onClick={() => onOrderBook(c)} className="p-2 rounded-md border border-[var(--border)] text-[var(--muted)] hover:text-white hover:border-[#3a3a42] transition-colors">
                        <BookOpen size={14} />
                      </button>
                      <button onClick={() => onBuy(c)} className="flex items-center gap-1.5 px-3 py-2 rounded-md bg-[var(--green)] text-[#052e20] text-[12px] font-semibold hover:bg-[#13b878] transition-colors">
                        <TrendingUp size={13} /> BUY
                      </button>
                    </div>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}
